"use strict";

var _underscore = require("underscore");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var INVITE_USER_FORM = {
  title: 'Add a member',
  saveLabel: 'Add',
  fields: {
    email: {
      kind: 'email'
    }
  }
};
var OrgEventList = /*#__PURE__*/function () {
  OrgEventList.$inject = ["$rootScope", "$filter", "orgService", "eventService", "userService", "modalService"];
  /* @ngInject */
  function OrgEventList($rootScope, $filter, orgService, eventService, userService, modalService) {
    var _this = this;
    _classCallCheck(this, OrgEventList);
    this.orgService = orgService;
    this.eventService = eventService;
    this.modalService = modalService;
    this.currentUser = userService.getCurrentUser();
    this.userIsSuperAdmin = userService.isSuperAdmin();
    this.eventInstancesByPeriods = $filter('eventInstancesByPeriods');
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.views = [{
      id: 'current',
      label: 'Live'
    }, {
      id: 'future',
      label: 'Future'
    }, {
      id: 'past',
      label: 'Past'
    }, {
      id: 'templates',
      label: 'Templates'
    }];
    this.activeViewIndex = 0;
    this.loading = true;
    this.joined = {};
    this.isOrgAdmin = (0, _underscore.memoize)(function (org) {
      return orgService.isMatchesOrgPermission('admin', org);
    });
    this.isMemberOf = (0, _underscore.memoize)(function (eventId) {
      return (0, _underscore.find)(_this.currentUser.roles, function (_ref) {
        var type = _ref.type,
          role = _ref.role,
          event_id = _ref.event_id;
        return type === 'event_permission' && role !== 'revoked' && event_id === eventId;
      });
    });
    this.userCanAddMembersToTeam = (0, _underscore.memoize)(function (orgId) {
      return userService.hasPermission('access_modification_realms.add_event_team_member', {
        org_id: orgId
      });
    });
    this.navigate = $rootScope.navigate;
  }
  return _createClass(OrgEventList, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this2 = this;
      if (changes.organisation && this.organisation) {
        this.loading = true;
        this.canJoinEvents = this.isOrgAdmin(this.organisation) || this.userCanAddMembersToTeam(this.organisation._id);
        this.orgService.getAllOrgEvents(this.organisation.name).then(function (data) {
          return _this2.sortEvents(data);
        }).finally(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "switchView",
    value: function switchView(id) {
      var _this3 = this;
      (0, _underscore.each)(this.views, function (view, index) {
        view.active = view.id === id;
        if (view.active) {
          _this3.activeViewIndex = index;
        }
      });
    }
  }, {
    key: "sortEvents",
    value: function sortEvents() {
      var _this4 = this;
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.eventCount = events.length;
      (0, _underscore.each)(this.views, function (view) {
        if (view.id === 'templates') {
          view.events = events.filter(function (e) {
            return e.is_template;
          });
        } else {
          view.events = _this4.eventInstancesByPeriods(events.filter(function (e) {
            return !e.is_template;
          }), view.id);
        }
      });
      var firstViewWithEvent = this.views.find(function (e) {
        return e.events.length > 0;
      }) || this.views[0];
      this.views = this.views.map(function (view) {
        return _objectSpread(_objectSpread({}, view), {}, {
          active: view === firstViewWithEvent
        });
      });
      this.switchView(firstViewWithEvent.id);
    }
  }, {
    key: "joinEvent",
    value: function joinEvent(event) {
      var _this5 = this;
      if (!this.canJoinEvents) {
        return;
      }
      var eventId = event._id;
      var eventNodeName = this.eventService.getEventInstanceNodeName(event);

      // needs to be called on cloud node
      this.eventService.addEventTeamMember(event, this.currentUser.name, 'manager', eventNodeName).then(function () {
        _this5.setFlashMessage("You were added to ".concat(_this5.getEventName(event)));
        _this5.joined[eventId] = true;
      }).catch(function (error) {
        console.error(error);
        _this5.setFlashMessage('Failed to join the event team', 'danger');
      });
    }
  }, {
    key: "inviteToEvent",
    value: function inviteToEvent(event) {
      var _this6 = this;
      if (!this.canJoinEvents) {
        return;
      }
      var email;
      this.modalService.openModalWithForm(INVITE_USER_FORM).then(function (model) {
        var eventNodeName = _this6.eventService.getEventInstanceNodeName(event);

        // needs to be called on cloud node
        _this6.eventService.addEventTeamMember(event, email = model.email, 'manager', eventNodeName).then(function () {
          var _event$description;
          return _this6.setFlashMessage("".concat(email, " was added to ").concat(event.eventname || ((_event$description = event.description) === null || _event$description === void 0 || (_event$description = _event$description.title) === null || _event$description === void 0 ? void 0 : _event$description.en) || 'workspace'));
        }).catch(function (error) {
          var msg = "Failed to add ".concat(email, " to workspace");
          var errorCode = error.status;
          if (errorCode === 404 || errorCode === 403) {
            msg = 'This user is not a Member in this Organization. In order to add this user to the Workspace, please add this user as an Organization Member first.';
          }
          _this6.setFlashMessage(msg, 'danger');
        });
      });
    }
  }, {
    key: "getEventName",
    value: function getEventName(event) {
      return this.eventService.getName(event);
    }
  }]);
}();
module.exports = angular.module('backstage.components.orgs.view-org.event-list', ['backstage.services']).component('bsOrgEventList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-event-list/org-event-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgEventList
}).name;